import { EnvironmentDescriptor } from './types';

export const legalEnvironment: EnvironmentDescriptor = {
  id: 'legal',
  translationNamespaces: ['common', 'legal'],
  featureFlags: {
    invoices: true,
    outlookSync: true,
    engineeringTemplates: false,
    timesheetDayLocks: false,
  },
  componentVisibility: {
    profileWorkflow: true,
    engineeringTemplates: false,
  },
};
